






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class Title extends Vue {
  @Prop({ type: String, default: "" }) text: string;
}
